import React from 'react';
import cx from 'classnames';
import { WithStyles, Theme, createStyles, withStyles } from '@material-ui/core';

import { Grid, Typography, units } from '@ha/dsl';

import Modal from './Modal';
import CloseBtn from './CloseBtn';

export const styles = (theme: Theme) =>
  createStyles({
    body: {
      backgroundColor: 'white',
      flexGrow: 1,
      overflowY: 'auto',
    },
    header: {
      backgroundColor: 'white',
      borderBottom: units.border(1, 'solid', theme.palette.grey[400]),
      paddingLeft: units.rem(2.25),
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: 'auto',
      margin: units.rem(0.625),
      [theme.breakpoints.up('sm')]: {
        maxHeight: '90vh',
        width: units.rem(32),
        margin: '1.875rem auto',
      },
      '&:focus': {
        outline: 0,
      },
    },
    narrow: {
      [theme.breakpoints.up('sm')]: {
        maxWidth: units.rem(22),
        marginRight: 'auto',
        marginLeft: 'auto',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        borderRadius: 0,
        position: 'fixed',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        margin: 0,
      },
    },
  });

interface Props {
  disableBackdropClick?: boolean;
  open: boolean;
  onClose: () => void;
  kind?: 'narrow';
  scrollable?: boolean;
  headerText?: string;
  info: React.ReactNode;
}

const SimpleModal: React.FC<Props & WithStyles<typeof styles>> = ({
  disableBackdropClick,
  open,
  children,
  kind = 'narrow',
  onClose,
  headerText,
  info,
  scrollable,
  classes,
}) => (
  <Modal
    disableBackdropClick={disableBackdropClick}
    open={open}
    onClose={onClose}
    scrollable={scrollable}
  >
    <div className={cx(classes.wrapper, classes[kind])}>
      {headerText && (
        <React.Fragment>
          <Grid
            alignItems="center"
            className={classes.header}
            container
            justify="space-between"
          >
            <Typography.H4 data-test-locator="SimpleModal header text">
              {headerText}
            </Typography.H4>
            <CloseBtn onClose={onClose} kind="fixed" />
          </Grid>
          <Grid className={classes.body} container>
            {children}
            {info}
          </Grid>
        </React.Fragment>
      )}
      {!headerText && (
        <React.Fragment>
          <CloseBtn onClose={onClose} />
          <Grid className={classes.body} container>
            {children}
            {info}
          </Grid>
        </React.Fragment>
      )}
    </div>
  </Modal>
);

export default withStyles(styles)(SimpleModal);
